export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/UYODesktopVideo-3f24753bae86574e3cd75a1d28b7dd7c.mp4";